import { useTranslation } from 'react-i18next';
import { IconSearch } from '@components/icons/icon-search';
import { useMagicSearch } from '@hooks/use-magic-search';
import { isMacPlatform } from '@utils/is-mac-platform';
import classNames from 'classnames';

import { MagicSearchTriggerProps } from './magic-search-trigger.type';

export const MagicSearchTrigger = ({ className }: MagicSearchTriggerProps) => {
  const { t } = useTranslation();
  const { isAvailable, openMagicSearch } = useMagicSearch();

  if (!isAvailable) return null;
  const isMac = isMacPlatform();

  // One button on every viewport, so the test id holds on both; below `lg` it folds to the icon.
  return (
    <button
      type='button'
      onClick={openMagicSearch}
      aria-label='Search'
      aria-keyshortcuts={isMac ? 'Meta+K' : 'Control+K'}
      className={classNames(
        'flex shrink-0 items-center gap-2 rounded-full border border-soft fill-primary p-2 text-body-s text-tertiary hover:border-hard lg:px-3',
        className
      )}
      data-testid='magic-search--trigger'>
      <IconSearch className='h-5 w-5 text-secondary' aria-hidden />
      <span className='hidden lg:inline'>{t('menu:magicSearchTrigger')}</span>
      <kbd className='hidden rounded-sm border border-soft px-1.5 font-sans text-body-xs text-tertiary lg:inline'>
        {isMac ? '⌘K' : 'Ctrl K'}
      </kbd>
    </button>
  );
};
